module.exports = __webpack_public_path__ + "_/_/src/components/sidebar/panel-load-sample/cat.png";